import { useNavigate, useLocation } from 'react-router-dom'
import rootStore from '@/app/store'

/**
 * Hook para manejar la creación de un nuevo chat
 * Incluye la lógica de confirmación si hay una generación activa
 *
 * @returns Función para iniciar un nuevo chat
 *
 * @example
 * ```tsx
 * const handleNewChat = useNewChat()
 * <button onClick={handleNewChat}>Nuevo Chat</button>
 * ```
 */
export const useNewChat = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleNewChat = () => {
    const { tool, chat } = rootStore
    const isStreaming = tool.generating || tool.awaitingFirstToken

    // Si hay generación activa, pedir confirmación
    if (isStreaming || chat.hasPendingPlugins) {
      const proceed = window.confirm(
        '¿Estás seguro de que quieres iniciar un nuevo chat? Se cancelará la generación actual y se perderán las acciones pendientes.',
      )
      if (!proceed) return

      tool.maybeCancelGeneration()
    }

    // Limpiar el chat actual y navegar a assistants
    chat.clearThread()
    navigate('/assistants', {
      replace: location.pathname === '/assistants',
      state: { reloadKey: new Date().getTime() },
    })
  }

  return handleNewChat
}
